import { Component, OnInit } from '@angular/core';
import { SearchTermservice } from '../../services/search/search-service.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { State } from '../../model/state.model';
import { StatesService } from '../../services/states/states.service';

@Component({
  selector: 'app-agent-summary',
  templateUrl: './agent-summary.component.html',
  styleUrls: ['./agent-summary.component.css']
})
export class AgentSummaryComponent implements OnInit {
  public agentId: any;
  public agentDetails: any;
  additionalInfo: FormGroup;
  submitSuccess;
  message;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  states: State[] = [];
  public disablePlatinumCb = true;
  public showPlatinumInput = false;
  public isAgentCompl: any = 'N';
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  lprDropdownList: any;
  gpsDropdownList: any;
  constructor(private searchTermservice: SearchTermservice, private statesService: StatesService) { }

  ngOnInit() {
    this.lprDropdownList = ['MVTrac', 'DRN', 'Plate Locate', 'Other'];
    this.gpsDropdownList = ['Clear Plan', 'Repo route', 'Other'];
    this.submitSuccess = false;
    this.agentId = localStorage.getItem("AgentId");
    this.searchTermservice.detailsOfAgent(this.agentId).subscribe(res => {
      this.agentDetails = res;
      this.agentDetails.lpr = this.agentDetails.lpr.split(',');
      this.agentDetails.gps = this.agentDetails.gps.split(',');
      this.isAgentCompl = this.agentDetails.IsAgentCompliant;
      this.disablePlatinumCb = true;
      if (localStorage.getItem('Role') === 'PC PAR Vendor Relations' || localStorage.getItem('Role') === 'PC PAR Admin' || localStorage.getItem('Role') === 'PC Site Admin' || localStorage.getItem('Role') === 'PC Client') {
        this.showPlatinumInput = true;
      }
      localStorage.setItem('AgentName', this.agentDetails.name);
    }, err => {
      this.DocTypeErrMsg = 'Vendor Summary Service' + ' ' + err;
      this.DocTypeErr = true;
    });
    this.getAllStates();
    this.role = localStorage.getItem("Role");
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }

  // get all states
  getAllStates() {
    this.statesService.getStates().subscribe(res => {
      this.states = res.States;
    });
  }

  //Submit
  submit() {
    this.searchTermservice.saveAdditionalAgent(this.agentDetails).subscribe(res => {
      if (res.Status == 200) {
        this.submitSuccess = true;
        this.message = 'Information Submitted successfully';
      }
    }, err => {
      this.DocTypeErrMsg = 'Vendor Summary Service' + ' ' + err;
      this.DocTypeErr = true;
      this.submitSuccess = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/agent-summary/agent-summary.component.ts